import { SearchIndexEnum } from "./search";

export enum Realm {
  local = "local",
  dev = "dev",
  stage = "stage",
  prod = "prod",
}

export enum Hostname {
  prod = "www.twilio.com",
  stage = "www.stage.twilio.com",
  dev = "www.dev.twilio.com",
  local = "www.local.twilio.com",
}

export enum Org {
  twilio = "twilio",
  sendGrid = "sendGrid",
  segment = "segment",
  zipwhip = "zipwhip",
}

export const zendeskAppIds = {
  sandbox: 1019469,
  prod: 1019473,
};

export interface ConfigValues {
  chatWidgetSource: string;
  chatWidgetSourceFile: string;
  csrfEndpoint: string;
  priorityLevelFieldId: string;
  hostName: string;
  currentAccountCookieDomain: string;
  searchIndex: SearchIndexEnum;
  incidentStatusPage: Record<Org, string>;
  segmentWriteKey: string;
  splitAuthorizationKey: string;
  consoleEndpoint: string;
  supportApiEndpoint: string;
  wiseOwlAPIEndpoint: string;
  supportAuthorizerEndpoint: string;
  recaptchaSiteKey: string;
  realm: Realm;
  webEndpoint: Hostname;
  ticketEscalationDelayMinutes: number;
}

export type Config = Record<Realm, ConfigValues>;
